/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rn_input_roman = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roman numeral`)
};

const es_rn_input_roman = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numeral romano`)
};

const de_rn_input_roman = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Römische Zahl`)
};

const nl_rn_input_roman = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Romeins getal`)
};

const fr_rn_input_roman = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiffre romain`)
};

const it_rn_input_roman = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numerale romano`)
};

const pt_br2_rn_input_roman = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numeral romano`)
};

const pt_rn_input_roman = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numeral romano`)
};

const ja_rn_input_roman = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ローマ数字`)
};

const zh_rn_input_roman = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`罗马数字`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rn_input_roman = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rn_input_roman(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rn_input_roman", locale)
	if (locale === "en") return en_rn_input_roman(inputs)
	if (locale === "es") return es_rn_input_roman(inputs)
	if (locale === "de") return de_rn_input_roman(inputs)
	if (locale === "nl") return nl_rn_input_roman(inputs)
	if (locale === "fr") return fr_rn_input_roman(inputs)
	if (locale === "it") return it_rn_input_roman(inputs)
	if (locale === "pt-BR") return pt_br2_rn_input_roman(inputs)
	if (locale === "pt") return pt_rn_input_roman(inputs)
	if (locale === "ja") return ja_rn_input_roman(inputs)
	return zh_rn_input_roman(inputs)
};